<template>
    <!-- <div class="speakol-toaster"> -->
      <div v-if="show" class="export-fixed-popup flex items-center">
        <div class="pop-up-container">
          <div v-if="icon" class="pop-up-icon">
            <img class="toaster-icons" :src="icon" alt="" />
          </div>
          <div class="pop-up-action ml-6">
            <slot name="close">
              <button @click="$emit('close')">{{ closeButtonText }}</button>
            </slot>
          </div>
          <div class="pop-up-status">
            <p>{{ message }}</p>
          </div>
        </div>
      </div>
    <!-- </div> -->
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: require('@/assets/images/logo/speakol-logo.svg')
    },
    closeButtonText: {
      type: String,
      default: 'Cancel'
    }
  }
}
</script>

<style lang="scss" scoped>

.export-fixed-popup {
  width: max-content;
  max-width: 90%;
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99991;
  background-color: #323232 !important;
  border-radius: 3px;
  padding: 15px 20px 10px 20px;

  .pop-up-icon {
    float: left;
    margin-right: 10px;

    img {
      width: 10px;
    }
  }

  .pop-up-status {
    float: left;

    p {
      color: white;
      font-weight: 300;
      font-size: 14px;
      padding-top: 2px;
    }
  }

  .pop-up-action {
    float: right;
    top: 20%;
    margin-left: 100px;
    padding-top: 2px;

    button {
      background-color: transparent;
      border: none;
      box-shadow: none;
      outline: none;
      color: white;
      font-weight: 500px;
      cursor: pointer;
    }
  }

  .toaster-icons {
    width: 24px !important;
  }

  @media (max-width: 576px) {
    .export-fixed-popup {
      position: fixed;
      bottom: 25px;
      left: 35%;
    }

    .pop-up-status {
      float: none !important;
    }

    .pop-up-action {
      margin-left: 0;
      margin-left: 20px;
      position: absolute;
      bottom: 45px;
      right: 20px;
    }

    .export-fixed-popup {
      bottom: 80px !important;
    }
  }
}
</style>
